"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const cardutil_1 = require("utils/cardutil");
const Sort_1 = require("utils/Sort");
const CubeContext_1 = __importDefault(require("../contexts/CubeContext"));
const Card_1 = require("./base/Card");
const Layout_1 = require("./base/Layout");
const ListGroup_1 = require("./base/ListGroup");
const Text_1 = __importDefault(require("./base/Text"));
const AutocardListItem_1 = __importDefault(require("./card/AutocardListItem"));
const AddToCubeModal_1 = __importDefault(require("./modals/AddToCubeModal"));
const WithModal_1 = __importDefault(require("./WithModal"));
const AutocardListItemLink = (0, WithModal_1.default)(AutocardListItem_1.default, AddToCubeModal_1.default);
const CompareGroup = ({ heading, both, onlyA, onlyB }) => {
    const bothCmc = (0, Sort_1.sortIntoGroups)(both, 'Mana Value');
    const onlyACmc = (0, Sort_1.sortIntoGroups)(onlyA, 'Mana Value');
    const onlyBCmc = (0, Sort_1.sortIntoGroups)(onlyB, 'Mana Value');
    return (react_1.default.createElement(ListGroup_1.ListGroup, null,
        react_1.default.createElement(ListGroup_1.ListGroupItem, { heading: true },
            react_1.default.createElement("div", { className: "w-full" },
                react_1.default.createElement(Layout_1.Flexbox, { direction: "row", gap: "2", justify: "center" },
                    react_1.default.createElement(Text_1.default, { sm: true, semibold: true }, heading)),
                react_1.default.createElement(Layout_1.Row, { className: "w-full" },
                    react_1.default.createElement(Layout_1.Col, { xs: 4 },
                        react_1.default.createElement(Layout_1.Flexbox, { direction: "row", gap: "2", justify: "center" },
                            react_1.default.createElement(Text_1.default, { sm: true, semibold: true },
                                "(",
                                both.length,
                                ")"))),
                    react_1.default.createElement(Layout_1.Col, { xs: 4 },
                        react_1.default.createElement(Layout_1.Flexbox, { direction: "row", gap: "2", justify: "center" },
                            react_1.default.createElement(Text_1.default, { sm: true, semibold: true },
                                "(",
                                onlyA.length,
                                ")"))),
                    react_1.default.createElement(Layout_1.Col, { xs: 4 },
                        react_1.default.createElement(Layout_1.Flexbox, { direction: "row", gap: "2", justify: "center" },
                            react_1.default.createElement(Text_1.default, { sm: true, semibold: true },
                                "(",
                                onlyB.length,
                                ")")))))),
        (0, Sort_1.getLabels)(null, 'Mana Value')
            .filter((cmc) => onlyACmc[cmc] || bothCmc[cmc] || onlyBCmc[cmc])
            .map((cmc) => (react_1.default.createElement(Layout_1.Row, { key: cmc, gutters: 0 }, [
            [bothCmc, 'both'],
            [onlyACmc, 'a'],
            [onlyBCmc, 'b'],
        ].map(([cards, key]) => (react_1.default.createElement(Layout_1.Col, { xs: 4, key: key }, (cards[cmc] || []).map((card, index) => (react_1.default.createElement(AutocardListItemLink, { key: card.index, card: card, className: index === 0 ? 'border-t border-border-secondary' : undefined, modalprops: { card: (0, cardutil_1.CardDetails)(card) } })))))))))));
};
const SummaryCard = ({ label, both, onlyA, onlyB }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Layout_1.Flexbox, { direction: "row", gap: "2", justify: "center" },
        react_1.default.createElement(Text_1.default, { semibold: true, lg: true }, label)),
    react_1.default.createElement(Layout_1.Row, null,
        react_1.default.createElement(Layout_1.Col, { xs: 4 },
            react_1.default.createElement(Layout_1.Flexbox, { direction: "col", alignItems: "center" },
                react_1.default.createElement(Text_1.default, { semibold: true, md: true }, "In Both cubes"),
                react_1.default.createElement(Text_1.default, { semibold: true, md: true },
                    "(",
                    both,
                    ")"))),
        react_1.default.createElement(Layout_1.Col, { xs: 4 },
            react_1.default.createElement(Layout_1.Flexbox, { direction: "col", alignItems: "center" },
                react_1.default.createElement(Text_1.default, { semibold: true, md: true }, "Only in Base Cube"),
                react_1.default.createElement(Text_1.default, { semibold: true, md: true },
                    "(",
                    onlyA,
                    ")"))),
        react_1.default.createElement(Layout_1.Col, { xs: 4 },
            react_1.default.createElement(Layout_1.Flexbox, { direction: "col", alignItems: "center" },
                react_1.default.createElement(Text_1.default, { semibold: true, md: true }, "Only in Comparison Cube"),
                react_1.default.createElement(Text_1.default, { semibold: true, md: true },
                    "(",
                    onlyB,
                    ")"))))));
const CompareView = ({ cards, both, onlyA, onlyB }) => {
    const { sortPrimary, sortSecondary, cube } = (0, react_1.useContext)(CubeContext_1.default) ?? {};
    const columnsPrimary = (0, Sort_1.sortIntoGroups)(cards, sortPrimary ?? 'Unsorted', !!cube?.showUnsorted);
    const columnsSecondary = {};
    const columnCounts = {};
    const bothCounts = { total: 0 };
    const onlyACounts = { total: 0 };
    const onlyBCounts = { total: 0 };
    const bothCopyTemp = both.slice(0);
    const onlyACopyTemp = onlyA.slice(0);
    const onlyBCopyTemp = onlyB.slice(0);
    for (const columnLabel of Object.keys(columnsPrimary)) {
        let onlyACount = 0;
        let onlyBCount = 0;
        let bothCount = 0;
        for (const card of columnsPrimary[columnLabel]) {
            const oracleId = card.details?.oracle_id ?? '';
            let index;
            if ((index = bothCopyTemp.indexOf(oracleId)) >= 0) {
                bothCount += 1;
                bothCopyTemp.splice(index, 1);
            }
            else if ((index = onlyACopyTemp.indexOf(oracleId)) >= 0) {
                onlyACount += 1;
                onlyACopyTemp.splice(index, 1);
            }
            else if ((index = onlyBCopyTemp.indexOf(oracleId)) >= 0) {
                onlyBCount += 1;
                onlyBCopyTemp.splice(index, 1);
            }
        }
        columnCounts[columnLabel] = columnsPrimary[columnLabel].length;
        bothCounts[columnLabel] = bothCount;
        bothCounts.total += bothCount;
        onlyACounts[columnLabel] = onlyACount;
        onlyACounts.total += onlyACount;
        onlyBCounts[columnLabel] = onlyBCount;
        onlyBCounts.total += onlyBCount;
        columnsSecondary[columnLabel] = (0, Sort_1.sortIntoGroups)(columnsPrimary[columnLabel], sortSecondary ?? 'Unsorted', !!cube?.showUnsorted);
    }
    const bothCopy = both.slice(0);
    const onlyACopy = onlyA.slice(0);
    const onlyBCopy = onlyB.slice(0);
    return (react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "3", className: "my-2" },
        react_1.default.createElement(Card_1.Card, null,
            react_1.default.createElement(Card_1.CardBody, null,
                react_1.default.createElement(SummaryCard, { label: "All Cards", both: both.length, onlyA: onlyA.length, onlyB: onlyB.length }))),
        (0, Sort_1.getLabels)(cards, sortPrimary ?? 'Unsorted', cube?.showUnsorted)
            .filter((columnLabel) => columnsPrimary[columnLabel])
            .map((columnLabel) => {
            const column = columnsSecondary[columnLabel];
            return (react_1.default.createElement(Layout_1.Flexbox, { key: columnLabel, direction: "col", gap: "1" },
                react_1.default.createElement(Card_1.Card, null,
                    react_1.default.createElement(Card_1.CardBody, null,
                        react_1.default.createElement(SummaryCard, { label: columnLabel, both: bothCounts[columnLabel], onlyA: onlyACounts[columnLabel], onlyB: onlyBCounts[columnLabel] }))),
                (0, Sort_1.getLabels)(Object.values(column).flat(), sortSecondary ?? 'Unsorted', cube?.showUnsorted)
                    .filter((label) => column[label])
                    .map((label) => {
                    const group = column[label];
                    const bothGroup = [];
                    const onlyAGroup = [];
                    const onlyBGroup = [];
                    for (const card of group) {
                        const oracleId = card.details?.oracle_id ?? '';
                        let index;
                        if ((index = bothCopy.indexOf(oracleId)) >= 0) {
                            bothGroup.push(card);
                            bothCopy.splice(index, 1);
                        }
                        else if ((index = onlyACopy.indexOf(oracleId)) >= 0) {
                            onlyAGroup.push(card);
                            onlyACopy.splice(index, 1);
                        }
                        else if ((index = onlyBCopy.indexOf(oracleId)) >= 0) {
                            onlyBGroup.push(card);
                            onlyBCopy.splice(index, 1);
                        }
                    }
                    return (react_1.default.createElement(CompareGroup, { key: label, heading: label, both: bothGroup, onlyA: onlyAGroup, onlyB: onlyBGroup }));
                })));
        })));
};
exports.default = CompareView;
